import { Component } from '@angular/core';
import { AppService } from './app.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'portal-operadora';

  constructor(private themeService: AppService) {}

  ngOnInit(): void {
    this.themeService.loadThemeColors(sessionStorage.getItem('theme'));
  }
}
